import { useEffect } from 'react';
import {
    MAIN_MENU_CLICK,
    PROVIDER_ACQUISITION_HEADER_CLICK,
    PROVIDER_ACQUISITION_MENU_CLICK,
    dispatchDataLayerTrackingEvent,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';

const GlobalPageEvents = () => {
    useEffect(() => {
        const elementIdToEventMappings = [
            ['mainMenuButton', MAIN_MENU_CLICK],
            ['headerBecomeOurProvider', PROVIDER_ACQUISITION_HEADER_CLICK],
            ['desktopMainMenuBecomeOurProvider', PROVIDER_ACQUISITION_MENU_CLICK],
            ['mobileMainMenuBecomeOurProvider', PROVIDER_ACQUISITION_MENU_CLICK],
        ];
        const listeners = [];
        elementIdToEventMappings.forEach(([id, eventName]) => {
            const element = document.getElementById(id);
            if (element) {
                const handler = () => dispatchDataLayerTrackingEvent(eventName);
                element.addEventListener('click', handler);
                listeners.push([element, handler]);
            }
        });

        return () => {
            listeners.forEach(([element, handler]) => {
                element.removeEventListener('click', handler);
            });
        };
    }, []);

    return null;
};

export default GlobalPageEvents;
